// The running app version.
//
// src/version.json is generated by scripts/sync-version.js from package.json at
// every build, so this string is baked into the JS bundle.
//
// That is exactly what makes it useful with OTA: an OTA update replaces the
// bundle, so this value moves with the bundle actually running — not with the
// APK Play installed. If the header shows a newer number than the Play release,
// the OTA landed. (`getBuiltinVersion()` from the updater plugin is the APK's
// own version, if you ever need to show both.)

import info from '../version.json';

export const APP_VERSION = info.version || '';
export const BUILD_DATE = info.buildDate || '';
export const GIT_COMMIT = info.gitCommit || '';
